export class ExternalLink {
  public id: number;
  public organizationId: string;
  public name: string;
  public url: string;
}
